import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "region-dashboards-ves" }
const _hoisted_2 = { class: "region-dashboards-ves__body container-page big export-page" }
const _hoisted_3 = { class: "region-dashboards-ves__cards-wrapper" }
const _hoisted_4 = { class: "region-dashboards-ves__rating-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionDashboardsMainFilterBlock = _resolveComponent("RegionDashboardsMainFilterBlock")!
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_RegionDashboardsAdditionFilterBlock = _resolveComponent("RegionDashboardsAdditionFilterBlock")!
  const _component_RegionDashboardsRepresentativeAbroadInfo = _resolveComponent("RegionDashboardsRepresentativeAbroadInfo")!
  const _component_RegionDashboardsBaseInfo = _resolveComponent("RegionDashboardsBaseInfo")!
  const _component_RegionDashboardsRatingCards = _resolveComponent("RegionDashboardsRatingCards")!
  const _component_RegionDashboardsIndicatorCards = _resolveComponent("RegionDashboardsIndicatorCards")!
  const _component_RegionDashboardsDynamicCards = _resolveComponent("RegionDashboardsDynamicCards")!
  const _component_DashboardsRatingTooltipContent = _resolveComponent("DashboardsRatingTooltipContent")!
  const _component_DashboardsRatingCard = _resolveComponent("DashboardsRatingCard")!
  const _component_DashboardsChart = _resolveComponent("DashboardsChart")!
  const _component_DashboardsChartsBlock = _resolveComponent("DashboardsChartsBlock")!
  const _component_DashboardsTables = _resolveComponent("DashboardsTables")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RegionDashboardsMainFilterBlock, {
        filter: _ctx.filter,
        plannedEventsRegionRfIds: _ctx.getPlannedEventsRegionRfIds,
        onChangeFilter: _ctx.changeFilter
      }, null, 8, ["filter", "plannedEventsRegionRfIds", "onChangeFilter"]),
      (_ctx.isShowData)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_DateActualDataSubtitle, {
              class: "region-dashboards-ves__subtitle",
              filter: _ctx.filterWithoutCountry,
              isSimpleYearLabel: ""
            }, null, 8, ["filter"]),
            _createVNode(_component_RegionDashboardsAdditionFilterBlock, {
              filter: _ctx.filter,
              onChangeFilter: _ctx.changeFilter,
              class: "region-dashboards-ves__main-filter"
            }, null, 8, ["filter", "onChangeFilter"]),
            (_ctx.getRepresentativeAbroadParamsFilter.countryId)
              ? (_openBlock(), _createBlock(_component_RegionDashboardsRepresentativeAbroadInfo, {
                  key: 0,
                  class: "region-dashboards-ves__representative-abroad-info",
                  filter: _ctx.getRepresentativeAbroadParamsFilter
                }, null, 8, ["filter"]))
              : _createCommentVNode("", true),
            _createVNode(_component_RegionDashboardsBaseInfo, {
              class: "region-dashboards-ves__base-info",
              filter: _ctx.filterWithoutCountry
            }, null, 8, ["filter"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_RegionDashboardsRatingCards, {
                class: "region-dashboards-ves__rating-cards",
                filter: _ctx.filterWithoutCountry
              }, null, 8, ["filter"]),
              _createVNode(_component_RegionDashboardsIndicatorCards, { filter: _ctx.filter }, null, 8, ["filter"])
            ]),
            _createVNode(_component_RegionDashboardsDynamicCards, { filter: _ctx.filterWithoutCountry }, null, 8, ["filter"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_DashboardsRatingCard, {
                title: _ctx.ratingCardTitles.HIGHEST,
                list: _ctx.topEffectiveRegionsRatingWithIndex,
                isLoading: _ctx.isRatingLoading,
                isShowDynamic: _ctx.isShowDynamicInRatingCards,
                year: _ctx.filter.year,
                sortOrder: _ctx.exportRegionEffectivnessRatingExcelSortOrder.DESCENDING
              }, {
                tooltipContent: _withCtx(() => [
                  _createVNode(_component_DashboardsRatingTooltipContent)
                ]),
                _: 1
              }, 8, ["title", "list", "isLoading", "isShowDynamic", "year", "sortOrder"]),
              _createVNode(_component_DashboardsRatingCard, {
                title: _ctx.ratingCardTitles.LOWEST,
                list: _ctx.getTopEffectiveRegionsRatingReverseWithIndex,
                isLoading: _ctx.isRatingLoading,
                isShowDynamic: _ctx.isShowDynamicInRatingCards,
                year: _ctx.filter.year,
                sortOrder: _ctx.exportRegionEffectivnessRatingExcelSortOrder.ASCENDING
              }, null, 8, ["title", "list", "isLoading", "isShowDynamic", "year", "sortOrder"])
            ]),
            _createVNode(_component_DashboardsChartsBlock, {
              calendarParams: _ctx.calendarParams,
              isChartVisible: _ctx.isChartVisible
            }, {
              chart: _withCtx(() => [
                _createVNode(_component_DashboardsChart, {
                  filter: _ctx.filterWithoutCountry,
                  title: _ctx.getChartTitle,
                  isSimpleYearLabel: ""
                }, null, 8, ["filter", "title"])
              ]),
              _: 1
            }, 8, ["calendarParams", "isChartVisible"]),
            _createVNode(_component_DashboardsTables, {
              params: _ctx.tableParams,
              hideSubjectFilter: "",
              class: "region-dashboards-ves__tables",
              onChangePlannedEventsFilter: _ctx.changePlannedEventsFilter
            }, null, 8, ["params", "onChangePlannedEventsFilter"])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}